import { DataTable, TableProvider } from "@xest-ui/data-table";
import MyPaginator from "components/PaginatedTable/MyPaginator";
import { DefaultTableComponents } from "components/PaginatedTable/DefaultTableComponents";
import { useHistory, useLocation } from "react-router-dom";
import updateQueryParams from "components/PaginatedTable/updateQueryParams";
import React from "react";
import { camelCase, mapKeys } from "lodash";
import getDigibasicTools from "services/getDigibasicTools";

const LatestSubmissionsTable = (props) => {
  const history = useHistory();
  const location = useLocation();
  const { setFeedRateToolId, setSelectedToolData, selectedToolId } = props;

  const toCamelCase = (obj) => {
    if (Array.isArray(obj)) {
      return obj.map((v) => toCamelCase(v));
    } else if (obj !== null && obj.constructor === Object) {
      return mapKeys(obj, (value, key) => camelCase(key));
    }
    return obj;
  };

  const cols = [
    {
      dataIndex: "tool_input_ref_no",
      title: "Reference No",
      filterType: {
        dbCol: "digibasic_tools.tool_input_ref_no",
        type: "string",
      },
      width: 40,
      ellipsis: { showTitle: true },
      render(text, record) {
        const isSelected = record?.digibasic_tool_id === selectedToolId;
        return (
          <span className={isSelected ? "selected-row-cell" : ""}>{text}</span>
        );
      },
    },
    {
      dataIndex: "created_at",
      title: "Created At",
      filterType: {
        dbCol: "digibasic_tools.created_at",
        type: "date",
      },
      width: 40,
      ellipsis: { showTitle: true },
      render(text, record) {
        const isSelected = record?.digibasic_tool_id === selectedToolId;
        return (
          <span className={isSelected ? "selected-row-cell" : ""}>{text}</span>
        );
      },
    },
    {
      title: "Actions",
      fixed: "right",
      width: 20,
      render(text, record) {
        const isSelected = record?.digibasic_tool_id === selectedToolId;

        return (
          <button
            type="button"
            className={`btn btn-sm ${
              isSelected ? "btn-primary" : "btn-info"
            }`}
            style={{ width: "8.5em", cursor: "pointer" }}
            onClick={() => {
              const { digibasic_tool_id } = record;
              setFeedRateToolId(digibasic_tool_id);
              setSelectedToolData(toCamelCase(record));
            }}
          >
            {isSelected ? "Selected" : "View Details"}
          </button>
        );
      },
    },
  ];

  return (
    <TableProvider
      params={{
        apiCallFn: async function (queryParams) {
          const res = await getDigibasicTools({ queryParams });
          return {
            data: res.data,
            total: res.data?.metadata?.total || 0,
          };
        },
        initialPageSize: 25,
        config: {
          tableIdentifier: "get-digibasic-tools-table",
          updateSearchQueryParams(newParams) {
            updateQueryParams({
              history,
              location,
              newParams,
            });
          },
        },
        initialSortCriteria: "-siemens_users.created_at",
        deps: [],
      }}
      components={DefaultTableComponents}
      columns={cols}
    >
      <DataTable pagination={false} />
      <MyPaginator />
    </TableProvider>
  );
};

export default LatestSubmissionsTable;